import {useState, useEffect} from 'react';
import {Platform} from 'react-native';
import firestore from '@react-native-firebase/firestore';
import {ChatTypeWithKey} from '~types/chat';
import {useUserStore} from '~providers/userStore/zustand';

/**
 * Hook to get the private chat with the support user for the current user
 * @returns The private chat object and loading state
 */
export const useGetContactChat = () => {
  const [contactChat, setContactChat] = useState<ChatTypeWithKey | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const {user} = useUserStore();
  const uid = user?.uid;
  const supportUserId = 'CmCCvWvpRVhhFlHdgU9QE6hbun82';

  useEffect(() => {
    if (!uid) {
      setIsLoading(false);
      return;
    }

    // Skip Firestore operations on web platform
    if (Platform.OS === 'web') {
      setIsLoading(false);
      return;
    }

    const unsubscribe = firestore()
      .collection('chats')
      .where('userIds', 'array-contains', uid)
      .where('type', '==', 'private')
      .onSnapshot(
        querySnapshot => {
          const chats = querySnapshot.docs.map(doc => ({
            ...doc.data(),
            key: doc.id,
          })) as ChatTypeWithKey[];

          // Find the chat that includes the support user
          const supportChat = chats.find(chat => 
            chat.userIds?.includes(supportUserId)
          );

          setContactChat(supportChat);
          setIsLoading(false);
        },
        error => {
          console.error('Error fetching private chat with support user:', error);
          setIsLoading(false);
        }
      );

    return () => unsubscribe();
  }, [uid, supportUserId]);

  return {contactChat, isLoading};
}; 